<modal id="video" class="">
	<div class="modal">
		<div class="modal__inner" (click)="startVideo()">
			<progress #progressBar
					  max="100"
					  class="modal__progressbar"
					  [value]="videoProgress">
			</progress>
			<div class="modal__cross" (click)="closeModal('video')">
				<img src="assets/images/education/icons/icon__cross-slider.svg" alt="">
			</div>
			<div class="modal__name" *ngIf="data">{{data.name}}</div>

			<video #videoPlayer
				   *ngIf="data"
				   class="modal__video"
				   playsinline
				   (loadedmetadata)="onVideoLoaded()">
				<source src="{{environment.url}}{{data.video}}" type="video/mp4">
			</video>
		</div>

		<div class="modal__navigation">
			<img (click)="resetModal()" class="modal__arrow modal__arrow--left reviews__slider-button-prev" src="assets/images/education/icons/icon__arrow-modal-slider--left.svg" alt="">
			<img (click)="resetModal()" class="modal__arrow modal__arrow--right reviews__slider-button-next" src="assets/images/education/icons/icon__arrow-modal-slider--right.svg" alt="">
		</div>
	</div>
	<div class="modal__background" (click)="closeModal('video')"></div>
</modal>
